import { Badge } from "@mantine/core";

import type { BotStatus } from "../../api/fleet";

const COLOR_MAP: Record<BotStatus, string> = {
  online: "green",
  paused: "yellow",
  offline: "gray",
  enrolling: "blue",
  disabled: "red",
};

export function StatusBadge({ status }: { status: BotStatus }) {
  return <Badge color={COLOR_MAP[status] ?? "gray"}>{status}</Badge>;
}
